export enum PropertyRegimeEnum {
  Indefinido = "Indefinido",
  ComunhaoParcial = "ComunhaoParcial",
  ComunhaoTotal = "ComunhaoTotal",
  SeparacaoTotal = "SeparacaoTotal"
}
